import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { InteractiveTagContainer } from './tag.styled';
/**
 * Tags container
 */
export const tagsContainerStyles = ({ theme }) => css `
	display: flex;
	flex-wrap: wrap;
	gap: ${pxToRem(theme.spacing['100'])};
	width: auto;
	margin: ${pxToRem(theme.spacing['300'])} 0;

	:has(${InteractiveTagContainer}) {
		gap: ${pxToRem(theme.spacing['200'])};
	}
`;
export const TagsContainer = styled.div `
	${tagsContainerStyles}
`;
//# sourceMappingURL=tags.styled.js.map